<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <!--<div-->
      <!--class="iconfont"-->
      <!--:class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"-->
      <!--&gt;</div>-->
      <svg class="icon" aria-hidden="true">
        <use
          :xlink:href="item.url === $route.path ? item.icon2 : item.icon1"
        ></use>
      </svg>
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "#icon-shouye1-copy",
          icon2: "#icon-shouye1",
          url: "/"
        },
        {
          name: "分类",
          icon1: "#icon-fenleiyemian-copy",
          icon2: "#icon-fenleiyemian",
          url: "/category"
        },
        {
          name: "购物车",
          icon1: "#icon-gouwuche2-copy",
          icon2: "#icon-gouwuche2",
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "#icon-gerenzhongxin-copy",
          icon2: "#icon-gerenzhongxin",
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
